import React, { useState } from 'react';
import { gql } from '@apollo/client';
import { useMutation, useQuery } from '@apollo/react-hooks';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalOverlay,
  Select,
  Spinner,
  Text,
  VStack,
  useToast,
} from '@chakra-ui/react';
import { useHistory, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import useUpdateCoalitionsCache from '../../Hooks/useUpdateCoalitionsCache';
import { CREATE_COALITION } from '../../GraphQL/Mutations';

const FETCH_COMPETITIONS = gql`
query fetchCompetitionsByEvent($eventId: Int!){
  fetchCompetitionsByEvent(eventId: $eventId) {
    id
    title
    fetchCompetition {
      group
      fetchCategory {
        id
        title
      }
    }
  }
}
`;

const eventCompetitionSort = (ec1, ec2) => {
  const cat1Id = ec1.fetchCompetition.fetchCategory.id;
  const cat2Id = ec2.fetchCompetition.fetchCategory.id;
  if (cat1Id === cat2Id) {
    return ec1.title.localeCompare(ec2.title);
  }
  return cat1Id - cat2Id;
};


export const CreateCoalitionModal = ({
  isOpen,
  onClose,
}) => {
  const { id } = useParams();
  const updateCache = useUpdateCoalitionsCache(parseInt(id, 10));
  const toast = useToast();
  const history = useHistory();
  const [eventCompetitionId, setEventCompetitionId] = useState();


  const { data, loading: eventCompetitionsLoading } = useQuery(FETCH_COMPETITIONS, {
    variables: {
      eventId: id,
    },
  });
  const eventCompetitions = data?.fetchCompetitionsByEvent
    .filter((ec) => ec.fetchCompetition.group)
    .sort(eventCompetitionSort);


  const [createCoalition, { createCoalitionLoading }] = useMutation(
    CREATE_COALITION,
    {
      onCompleted: (res) => {
        updateCache(res.createCoalition.coalition);
        history.push(`/event-manage/${id}/coalitions/${res.createCoalition.coalition.id}/edit`);
      },
      onError: (err) => {
        toast({
          title: err.message,
          status: 'error',
          isClosable: true,
          position: 'top',
        });
      },
    },
  );

  const onSubmit = () => {
    createCoalition({
      variables: {
        eventCompetitionId: parseInt(eventCompetitionId, 10),
        schoolIds: [],
      },
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create Coalition</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack>
            <Text>Select competition:</Text>
            {eventCompetitionsLoading ? <Spinner /> : (
              <Select
                value={eventCompetitionId}
                onChange={(e) => setEventCompetitionId(e.target.value)}
              >
                <option
                  value={null}
                  selected={!eventCompetitionId}
                  style={{ display: 'none' }}
                  disabled
                >
                  none
                </option>
                {eventCompetitions.map((ec) => (
                  <option key={ec.id} value={ec.id}>{ec.title}</option>
                ))}
              </Select>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onSubmit} isLoading={createCoalitionLoading} disabled={!eventCompetitionId}>
            Create Coalition
          </Button>
          <Button colorScheme="gray" variant="outline" mr={3} onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
CreateCoalitionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
